<script>
    import Http from '@/api/data';
    import { EventBus } from '@/event-bus';

    export default {
        name: 'PromoterCustomization',
        data() {
            return {
                customCss: null
            };
        },
        created() {
            let url = new URL(window.location);
            if (url.searchParams.get('key'))
                Http.getData(url.protocol + '//' + process.env.API_LIST.FO + '/promoteur-personnalisation?key=' + url.searchParams.get('key')).then(payload => {
                    if (payload) {
                        this.customCss = payload.css;
                        EventBus.$emit('setCustomCss', this.customCss);
                    }
                },
                errorMessage => {
                    console.error('Promoter customization API error', errorMessage);
                });
        },
        render(h) {
            return h('div');
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/PromoterCustomization.vue